import React, { useEffect, useState } from "react"
import { verifyEmailOtp, sendEmail as sendEmailID } from "../../store/actions"
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  FormGroup,
  Label,
  Alert,
  Spinner,
} from "reactstrap"

import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
const EmailOtp = ({
  email
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()
  const [inputEmailOTP, setInputEmailOTP] = useState();
  const handleOpen = () => {
    setIsOpen(true)
    dispatch(sendEmailID({ email: email }))
    console.log(email)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleSubmit = () => {

    //setIsOpen(false)
    dispatch(verifyEmailOtp({ email: email, OTP: parseInt(inputEmailOTP) }))
  }
  const sendEmailOtp = () => {
    dispatch(sendEmailID({ email: email }))
  }

  const emailotpReducer = state => state.emailotpReducer
  const OTPSTATE = createSelector(emailotpReducer, OTP => ({
    emailverifyEmailOtpError: OTP.emailverifyEmailOtpError,
    emailotpResponseMessage: OTP.emailotpResponseMessage,
    emailotpVerified: OTP.emailotpVerified,
    emailotpVerified: OTP.emailotpVerified,
    verifyLoading: OTP.verifyLoading,
    loading: OTP.loading
  }))
  const { emailotpResponseMessage, emailverifyEmailOtpError, emailotpVerified, verifyLoading, loading } = useSelector(OTPSTATE)

  useEffect(() => {
    emailotpResponseMessage === "OTP verified" ? handleClose() : ""
  }, [emailotpResponseMessage])
  return (
    <div>
      {emailotpVerified ? (
        <Button color="success">
          OTP verified
        </Button>
      ) : (
        <Button color="primary" onClick={handleOpen}>
          Verify Email
        </Button> 
      )}

      <Modal isOpen={isOpen} toggle={handleClose}>
        <ModalHeader>
          <p>OTP is sent to your registered Email Id</p>
          {emailotpResponseMessage && (
            <Alert
              color={
                emailotpResponseMessage === "OTP verified" ? "success" : "warning"
              }
            >
              {emailotpResponseMessage}
            </Alert>
          )}
        </ModalHeader>
        <ModalBody>
          <form>
            <FormGroup>
              <Label for="otpInput"></Label>
              <Input
                type="text"
                id="otpInput"
                placeholder="Enter OTP"
                value={inputEmailOTP}
                onChange={e => setInputEmailOTP(e.target.value)}
              />
            </FormGroup>
            {verifyLoading ? (
              <div display={"inline-block"} className="btn btn-primary">
                <Spinner size="sm" />
              </div>
            ) : (
              <input
                className="btn btn-primary ms-1"
                type="button"
                value={"Verify OTP"}
                onClick={handleSubmit}
              />
            )}
            &nbsp;&nbsp;
            or
            &nbsp;&nbsp;
            {loading ? (
              <div display={"inline-block"} className="btn btn-primary ms-1">
                <Spinner size="sm" />
              </div>
            ) : (
              <input
                className="btn btn-primary ms-1"
                type="button"
                value={"Resend Otp"}
                onClick={() => sendEmailOtp()}
              />
            )}
          </form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default EmailOtp
